import { Box } from '@rbilabs/universal-components';

import { primitive, spacing } from 'styles/constants';
export const TotalsContainer = Box.withConfig({
  paddingTop: spacing.$0_5,
  paddingX: '$9',
  paddingBottom: '$5',
  marginTop: '$4',
  marginBottom: '$6',
  borderBottomWidth: '1px',
  borderBottomColor: primitive.$bbqBrown,
  _text: {
    fontFamily: 'heading',
  },
});
